import _axios from '@/plugins/axios';
import { CCMError } from '../../../lib/Errors';

export default {
  async getTimeLogEntryCountsByPatientid (patientId) {
    const response = await _axios.get(`/ccmtimelogentry/gettimelogentrycountsbypatientid/${patientId}`);
    if (response.data.resFlag) {
      return response.data;
    }
    throw new CCMError('Error getting CCM time log');
  },
  async getTimeLogEntryCountsByPatientidByDate (data) {
    const { patientId, dateHeader } = data;
    const response = await _axios.get(`/ccmtimelogentry/gettimelogentrybypatientidbydate/${patientId}`, { headers: { dateHeader } });
    if (response.data.resFlag) {
      return response.data;
    }
    throw new CCMError('Error getting CCM time log');
  },
  async getCCMTimeLogsByPatientId (patientId) {
    const response = await _axios.get(`/ccmtimelogentry/getccmbypatientid/${patientId}`);
    if (response.data.resFlag) {
      return response.data;
    }
    throw new CCMError('Error getting CCM time log');
  },
  async getCCMTimeLogsByCCMId (ccmId) {
    const response = await _axios.get(`/ccmtimelogentry/getbyccmid/${ccmId}`);
    if (response.data.resFlag) {
      return response.data;
    }
    throw new CCMError('Error getting CCM time log');
  },
  async getCCMTimeLog (id) {
    const response = await _axios.get(`/ccmtimelogentry/${id}`);
    if (response.data.resFlag) {
      return response.data;
    }
    throw new CCMError('Error getting CCM time log');
  },
  async updateCCMTimeLog (id, body) {
    const response = await _axios.put(`/ccmtimelogentry/${id}`, body);
    if (response.data.resFlag) {
      return response.data;
    }
    throw new CCMError('Error updating CCM time log');
  },
  async updateCCMTimeLogByCCMId (ccmID, body) {
    const response = await _axios.put(`/ccmtimelogentry/editbyccmid/${ccmID}`, body);
    if (response.data.resFlag) {
      return response.data;
    }
    throw new CCMError('Error updating CCM time log');
  },
  async deleteCCMTimeLog (id) {
    const response = await _axios.delete(`/ccmtimelogentry/${id}`);
    if (response.data.resFlag) {
      return response.data;
    }
    throw new CCMError('Error deleting CCM time log');
  },
  async addCCMTimeLog (body) {
    const response = await _axios.post('/ccmtimelogentry/', body);
    if (response.data.resFlag) {
      return response.data;
    }
    throw new CCMError('Error adding CCM time log');
  },
};
